import type { CSSProperties } from 'react'
import { getPathAxes } from 'common/components/DataViz/charts/elements/paths/js/pathGeometry'
import type { ChunkLineProps } from './ChunkLine'

export const ChunkLabel = ({ axes, start_time, end_time, status }: ChunkLineProps): JSX.Element | null => {
  const { x } = getPathAxes({ axes })
  if (!x || status === 'done') return null
  const box_start = x.scale(start_time)
  const box_end = x.scale(end_time)
  if (box_start === undefined || box_end === undefined) return null

  return (
    <div
      className={`demo-chunk-label demo-chunk-label--${status}`}
      style={{ '--chunk-start': box_start, '--chunk-width': Math.max(0, box_end - box_start) } as CSSProperties}
    >
      {status !== 'error' && <span className='demo-chunk-label__text'>{status === 'loading' ? 'Loading…' : 'Waiting…'}</span>}
    </div>
  )
}
